import React from "react";
import { UI_BODY_SM, UI_BODY_SEMIBOLD_SM, colors2, UI_BODY_BOLD_SM } from "oolib";

export const totalDataLossWarningConfig = {
  title: "Critical Warning",
  confirmText: "Continue with data loss",
  headerBg: colors2.red,
  headerColor: colors2.white,
  // The warning icon on this option in the field-type dropdown, and the reason
  // appended to that option's tooltip.
  markerColor: colors2.red,
  markerTooltip:
    "Existing data in this column will be permanently deleted if you change to this type as conversion to the new type is not compatible.",
  render: ({ fieldLabel, fromDisplay, toDisplay }) => (
    <>
      <UI_BODY_SM>
        Changing "<span className="UI_BODY_BOLD_SM">{fieldLabel}</span>"
        from <span className="UI_BODY_BOLD_SM">{fromDisplay}</span> to{" "}
        <span className="UI_BODY_BOLD_SM">{toDisplay}</span> will
        permanently modify your data.
      </UI_BODY_SM>
      <UI_BODY_SM>
        This field's existing values cannot be carried over to a {toDisplay}{" "}
        field. Converting it will permanently delete the data currently stored
        in this column.
      </UI_BODY_SM>
      <UI_BODY_BOLD_SM>This action is irreversible.</UI_BODY_BOLD_SM>
    </>
  ),
};

export const partialDataLossWarningConfig = {
  title: "Warning",
  confirmText: "Continue with data loss",
  headerBg: "#ECBB28", // replace with yellowFill when it exists in oolib
  headerColor: colors2.grey90,
  // The warning icon on this option in the field-type dropdown, and the reason
  // appended to that option's tooltip.
  markerColor: "#ECBB28", // replace with yellowFill
  markerTooltip:
    "Only the first value in each document will be kept if you change to this type.",
  render: ({ fieldLabel, fromDisplay, toDisplay }) => (
    <>
      <UI_BODY_SM>
        Changing "<span className="UI_BODY_BOLD_SM">{fieldLabel}</span>"
        from <span className="UI_BODY_BOLD_SM">{fromDisplay}</span> to{" "}
        <span className="UI_BODY_BOLD_SM">{toDisplay}</span> will
        permanently modify your data.
      </UI_BODY_SM>
      <UI_BODY_SM>
        Documents holding more than one value in this field will keep only the
        first one. Every other value will be permanently deleted.
      </UI_BODY_SM>
      <UI_BODY_BOLD_SM>This action is irreversible.</UI_BODY_BOLD_SM>
    </>
  ),
};

/**
 * The config for a severity from getFieldTypeChangeDataLoss — drives both the
 * marker on the field-type option and the modal.
 */
export const getWarningConfig = (severity) =>
  severity === "partial"
    ? partialDataLossWarningConfig
    : totalDataLossWarningConfig;
